import { ensureEmojiCache, getAllEmojis as getAllFromCache } from '../emojiCache';
import { sortByRelevance } from '../sortByRelevance';
import { escapeRegex } from '../stringUtils';

const getAllEmojis = () => {
  ensureEmojiCache();
  return getAllFromCache().filter((e) => e.category !== 'Component');
};

export const searchEmojis = (query, options = {}) => {
  const { limit = 5, sortByRelevance: shouldSort = false } = options;

  if (!query) return [];

  const allEmojis = getAllEmojis();
  const normalizedQuery = query.toLowerCase();
  const regex = new RegExp(escapeRegex(normalizedQuery), 'i');

  // Filter emojis that match the query
  const matchingEmojis = allEmojis.filter((emoji) => {
    // Exclude variant emojis
    if (emoji.shortcode.includes('::')) return false;

    // Exclude deactivated emojis
    if (emoji.sort_order < 0) return false;

    // Check search against shortcode
    if (regex.test(emoji.shortcode)) {
      return true;
    }

    // Check search against category
    if (emoji.category && regex.test(emoji.category)) {
      return true;
    }

    // Check search against aliases array
    if (emoji.aliases && Array.isArray(emoji.aliases)) {
      return emoji.aliases.some((alias) => regex.test(alias));
    }

    return false;
  });

  // Dedupe system emojis by shortcode, preferring the lower sort_order. Custom
  // emojis dedupe by id instead: the same shortcode in two of the user's chats
  // is two distinct emojis, and both should be offered.
  const dedupedEmojis = matchingEmojis
    .sort((a, b) => a.sort_order - b.sort_order)
    .reduce((acc, emoji) => {
      const key = emoji.kind === 'custom' ? `custom:${emoji.id}` : `system:${emoji.shortcode}`;
      if (!acc.some((e) => e.key === key)) acc.push({ key, emoji });
      return acc;
    }, [])
    .map((e) => e.emoji);

  // Sort by relevance if requested
  const results = shouldSort ? sortByRelevance(dedupedEmojis, query, 'shortcode') : dedupedEmojis;

  // Return limited results
  return results.slice(0, limit);
};

// Clear cache when needed (useful for testing or when emoji data changes)
export const clearEmojiSearchCache = () => {};
